import React from 'react';
import './ArithmeticQuizResult.css';

function QuizResult({ score, total, onRestart }) {
  // Calculate percentage score
  const percentageScore = ((score / total) * 100).toFixed(2);

  // Determine feedback message
  let feedbackMessage;
  if (percentageScore === 100) {
    feedbackMessage = "Perfect score! You're a math whiz!";
  } else if (percentageScore >= 75) {
    feedbackMessage = "Great job! You really know your stuff.";
  } else if (percentageScore >= 50) {
    feedbackMessage = "Good effort! Keep practicing!";
  } else {
    feedbackMessage = "Don't be discouraged! Try again!";
  }

  return (
    <div className="result-container">
      <h2>Quiz Complete!</h2>
      <p>You scored {score} out of {total}.</p>
      <p>Your score: {percentageScore}%</p>
      <p>{feedbackMessage}</p>
      <button onClick={onRestart}>Restart Quiz</button>
    </div>
  );
}

export default QuizResult;
